import { habit, isNull } from "@habits/powersync";

/**
 * ┌─────────────────────────────────────────────────────────────────────────┐
 * │ SOFT-DELETE — CENTRALIZED LIVE LAYER (single choke point)               │
 * └─────────────────────────────────────────────────────────────────────────┘
 *
 * This module is the single home where the invariant "live row = `deleted_at IS
 * NULL`" is expressed for tables with trash in this repo (`habit`). Every
 * live read composes these predicates (domain builders in
 * habits/queries and live layer import them here). ONLY reads that
 * see deleted rows are trash (`getTrashedHabitsQuery`) and harmless
 * id-scoped lookups, both declared in whitelist of guard
 * (`guard-manifest.ts`).
 *
 * Why centralize? A scattered invariant was the #1 bug family of the
 * campaign (stats/counters/PATCH ignoring `deleted_at`). With single choke
 * point + anti-regression guard, adding raw read to these tables
 * outside whitelist BREAKS the build (see
 * `live/__tests__/live-access-guard.test.ts`).
 *
 * Schema NOTE (habit-streak): only `habit` has `deleted_at`.
 * `habit_completion` and `habit_reminder` are NOT soft-delete: they remain
 * intact when habit is moved to trash (reappear upon restore) and are
 * deleted in cascade upon purging their parent `habit`.
 */

/**
 * Predicates for "live habit": habit is not in trash. Applied to
 * ALL live views/queries of `habit`. `habit` has no parent table with trash,
 * so `deleted_at IS NULL` on habit itself is sufficient.
 */
export function liveHabitFilters() {
  return [isNull(habit.deleted_at)];
}
